import { render } from "./GeneratePayslip.vue?vue&type=template&id=56828498&scoped=true"
import script from "./GeneratePayslip.vue?vue&type=script&lang=js"
export * from "./GeneratePayslip.vue?vue&type=script&lang=js"

import "./GeneratePayslip.vue?vue&type=style&index=0&id=56828498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56828498"]])

export default __exports__